import React from "react";
import { useTranslation } from "react-i18next";
import { Divider, Stack } from "@mui/material";

import Typography from "components/basic/typography";

import AttendeeRow from "../AttendeeRow";
import { Attendee, LeadCustomer } from "../../../../types";

interface AttendeeListProps {
  attendees: Attendee[];
  leadsByEmail?: Map<string, LeadCustomer>;
  onViewQuotes: (customer: LeadCustomer | null) => void;
  onMessage?: (accountId: number) => void;
  onApplyProposedTime?: (date: string, from: string, to: string) => void;
}

const AttendeeList: React.FC<AttendeeListProps> = ({
  attendees,
  leadsByEmail,
  onViewQuotes,
  onMessage,
  onApplyProposedTime,
}) => {
  const { t } = useTranslation("calendar");
  if (attendees.length === 0) {
    return null;
  }

  return (
    <>
      <Divider sx={{ my: 2 }} />
      <Typography
        variant="subtitle2"
        style={{ fontWeight: 600, marginBottom: 8 }}
      >
        {t("details.attendees")}
      </Typography>
      <Stack spacing={1.5}>
        {attendees.map((a) => {
          const customer = leadsByEmail?.get(a.email);
          const hasQuotes = (customer?.quotes.length ?? 0) > 0;
          const accountId = customer?.accountId;
          return (
            <AttendeeRow
              key={a.email}
              attendee={a}
              hasQuotes={hasQuotes}
              onViewQuotes={() => onViewQuotes(customer ?? null)}
              onMessage={
                onMessage && accountId ? () => onMessage(accountId) : undefined
              }
              onApplyProposedTime={onApplyProposedTime}
            />
          );
        })}
      </Stack>
    </>
  );
};

export default AttendeeList;
